import React, { useEffect, useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from "@mui/material/";
import { useTranslation } from "react-i18next";
import {
  RowsPerAcriss,
  SingleLocationAvailabilityReportResponses,
} from "../../availability/service/availabilityReportInterfaces";
import FleetPlanningToolbar from "../../planning/FleetPlanningToolbar";
import SingleAcrissTables from "./SingleAcrissTables";
import SingleAcrissTotalsTables from "./SingleAcrissTotalsTables";
import EnumChangeName from "../../common/EnumChangeName";

const SingleLocationTable: React.FC<
  SingleLocationAvailabilityReportResponses
> = ({
  location,
  rowsPerAcriss,
  configurationThresholds,
  fullDays,
  index,
  isAccordion,
  totalRowsByLocation,
  totalCurrentAvailability,
  totalCurrentUtilization,
  totalCurrentAssignment,
}) => {
  const { t } = useTranslation(["operation"]);
  const [expanded, setExpanded] = useState<boolean>(index === 0 ? true : false);
  const [allData, setAllData] = useState<RowsPerAcriss[]>([]);

  const { locationType } = EnumChangeName();

  useEffect(() => {
    rowsPerAcriss.forEach(function (acriss) {
      acriss.isVisible = true;
    });
    setAllData(rowsPerAcriss);
  }, []);

  const onAcrissRowClick = (
    event: React.ChangeEvent<HTMLInputElement>,
    acrissLabel: string
  ) => {
    let temp = [...rowsPerAcriss];
    temp[temp.findIndex((el) => el.acriss === acrissLabel)].isVisible =
      event.target.checked;
    setAllData(temp);
  };

  return (
    <Box className="tablesContainer singleLocation">
      {isAccordion && (
        <Accordion expanded={expanded}>
          <AccordionSummary
            expandIcon={
              expanded ? (
                <RemoveIcon
                  onClick={() => setExpanded(false)}
                  className="expandIcon"
                />
              ) : (
                <AddIcon
                  onClick={() => setExpanded(true)}
                  className="expandIcon"
                />
              )
            }
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography className="locationName">
              {location?.locationName
                ? `${location?.locationName} (${locationType(location.locationType)})`
                : `${t("availabilityReport.missingName")} 
              ${location?.locationId}`}
            </Typography>
            <div>
              {allData.map((acrissRow) => (
                <FormControlLabel
                  key={acrissRow.acriss}
                  control={
                    <Checkbox
                      defaultChecked
                      sx={{
                        color: "rgb(200, 1, 125)",
                        "&.Mui-checked": {
                          color: "rgb(200, 1, 125)",
                        },
                      }}
                      onChange={(e) => onAcrissRowClick(e, acrissRow.acriss)}
                    />
                  }
                  className="locationCheckbox"
                  label={acrissRow.acriss}
                />
              ))}
            </div>
          </AccordionSummary>
          <AccordionDetails>

            <SingleAcrissTotalsTables
              totalRowsBylocation={totalRowsByLocation}
              totalCurrentAssignment={totalCurrentAssignment}
              totalCurrentAvailability={totalCurrentAvailability}
              totalCurrentUtilization={totalCurrentUtilization}
              configurationThresholds={configurationThresholds}
              fullDays={fullDays}
            />

            {allData.map((acrissRow) => (
              <SingleAcrissTables
                singleAcrissRow={acrissRow}
                configurationThresholds={configurationThresholds}
                fullDays={fullDays}
              />
            ))}
          </AccordionDetails>
        </Accordion>
      )}
      {!isAccordion && (
        <span>
          <Grid sx={{ display: "flex" }}>
            <Grid item xs={6}>
              <FleetPlanningToolbar
                year={t("availabilityReport.total")}
                yearColor={"#011e41"}
                isExelButton={false}
                hideExcelButton={true}
                radiusTopRight={0}
              />
            </Grid>
            <Grid item xs={6}>
              <FleetPlanningToolbar
                year={""}
                yearColor={"#011e41"}
                isExelButton={false}
                hideExcelButton={true}
                radiusTopLeft={0}
              />
            </Grid>
          </Grid>

          <SingleAcrissTotalsTables
            totalRowsBylocation={totalRowsByLocation}
            totalCurrentAssignment={totalCurrentAssignment}
            totalCurrentAvailability={totalCurrentAvailability}
            totalCurrentUtilization={totalCurrentUtilization}
            configurationThresholds={configurationThresholds}
            fullDays={fullDays}
          />

          {allData.map((acrissRow) => (
            <SingleAcrissTables
              singleAcrissRow={acrissRow}
              configurationThresholds={configurationThresholds}
              fullDays={fullDays}
            />
          ))}
        </span>
      )}
    </Box>
  );
};

export default SingleLocationTable;
